import { getHoveredNode } from './utils';
import type { DragEvent } from 'react';
import type { DnDProps } from './types';
import { getPlaceholderNodes } from '../../utils';
import { isDuplicateModifier } from '@src/components/custom-nodes/generic-node/hooks/duplicate-modifier';
import type { CustomNode } from '@src/components/custom-nodes/types';

type GetOnDragOverProps = Pick<DnDProps, 'reactFlowInstance'>;
export const getOnDragOver = ({ reactFlowInstance }: GetOnDragOverProps) => (event: DragEvent<HTMLDivElement>) => {
  event.preventDefault();
  // Must agree with the `effectAllowed` set on dragstart - see isDuplicateModifier.
  event.dataTransfer.dropEffect = isDuplicateModifier(event) ? 'copy' : 'move';
  const nodes = reactFlowInstance?.getNodes() as CustomNode[];
  const setNodes = reactFlowInstance?.setNodes;
  const placeholderNodes = getPlaceholderNodes(nodes);
  const hoveredNode = getHoveredNode({ nodes: placeholderNodes, event, reactFlowInstance });

  if (hoveredNode) {
    setNodes?.((nds) => {
      return nds.map((n) => {
        if (n.id === hoveredNode.id) {
          return {
            ...n,
            selected: true,
          };
        }
        return n;
      });
    });
  } else if (placeholderNodes.filter((node) => node.selected).length > 0) {
    setNodes?.((nds) => {
      return nds.map((n) => {
        if (n.id.startsWith('placeholder_')) {
          return {
            ...n,
            selected: false,
          };
        }
        return n;
      });
    });
  }
};
